(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('CompletionsByRangeController', CompletionsByRangeController);

    CompletionsByRangeController.$inject = ['$scope', '$stateParams', '$sce', 'common', 'dataservice', '$timeout' ];
    /* @ngInject */
    function CompletionsByRangeController($scope, $stateParams, $sce, common, dataservice, $timeout) {
        var vm = this;
        vm.title = "Completions By Range";
        vm.isLoading = true;
        vm.filters = {
            fromDate: new Date(),
            toDate: new Date()
        };

        vm.forDateOpen = false;
        vm.openDatePicker = openDatePicker;
        vm.generate = generate;
       
        vm.openDatePicker = openDatePicker;
        vm.dpStatus = {
            fromDateOpen: false,
            toDateOpen: false
        }

        vm.generated = false;


        vm.userService = common.userService;
        vm.bookingCompletionsGraphData = [];
        vm.bookingCompletionsGraphLabels = [];

        vm.bookingCompletionsByDepartmentGraphData = [];
        vm.bookingCompletionsByDepartmentGraphLabels = [];
        vm.bookingCompletionsByUserGraphData = [];
        vm.bookingCompletionsByUserGraphLabels = [];
        vm.taskCompletionsGraphData = [];
        vm.taskCompletionsGraphLabels = [];
        vm.taskCompletionsByDepartmentGraphData = [];
        vm.taskCompletionsByDepartmentGraphLabels = [];
        vm.taskCompletionsByUserGraphData = [];
        vm.taskCompletionsByUserGraphLabels = [];

        vm.logCompletionsGraphData = [];
        vm.logCompletionsGraphLabels = [];
        vm.logCompletionsByDepartmentGraphData = [];
        vm.logCompletionsByDepartmentGraphLabels = [];
        vm.logCompletionsByUserGraphData = [];
        vm.logCompletionsByUserGraphLabels = [];
        vm.chartOptions = {
            legend: { display: true, position: 'bottom' },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        var allData = data.datasets[tooltipItem.datasetIndex].data;
                        var tooltipLabel = data.labels[tooltipItem.index];
                        var tooltipData = allData[tooltipItem.index];
                        var total = 0;
                        for (var i in allData) {
                            total += allData[i];
                        }
                        var tooltipPercentage = Math.round((tooltipData / total) * 100);
                        return tooltipLabel + ': ' + tooltipPercentage + '%';
                    }
                }
            }
        };

        activate();

        function activate() {
            
            var promises = []
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function openDatePicker(isStart) {
            if (isStart) {
                vm.dpStatus.fromDateOpen = true;
                vm.dpStatus.toDateOpen = false;
            }
            else {
                vm.dpStatus.fromDateOpen = false;
                vm.dpStatus.toDateOpen = true;
            }

        }

        function generate() {
            var fromDate = moment(vm.filters.fromDate);
            var toDate = moment(vm.filters.toDate);
         

            return dataservice.getItems('api/AnalyticsReport/CompletionsByReport?localFromDate=' + fromDate.toISOString() + "&localToDate=" + toDate.toISOString())
                .then(function (response) {
                    var data = response.data;
                    vm.bookingCompletionsGraphData = data.BookingCompletionsGraphData;
                    vm.bookingCompletionsGraphLabels = data.BookingCompletionsGraphLabels;
                    vm.bookingCompletionsByDepartmentGraphData = data.BookingCompletionsByDepartmentGraphData;
                    vm.bookingCompletionsByDepartmentGraphLabels = data.BookingCompletionsByDepartmentGraphLabels;
                    vm.bookingCompletionsByUserGraphData = data.BookingCompletionsByUserGraphData;
                    vm.bookingCompletionsByUserGraphLabels = data.BookingCompletionsByUserGraphLabels;
                    vm.taskCompletionsGraphData = data.TaskCompletionsGraphData;
                    vm.taskCompletionsGraphLabels = data.TaskCompletionsGraphLabels;
                    vm.taskCompletionsByDepartmentGraphData = data.TaskCompletionsByDepartmentGraphData;
                    vm.taskCompletionsByDepartmentGraphLabels = data.TaskCompletionsByDepartmentGraphLabels;
                    vm.taskCompletionsByUserGraphData = data.TaskCompletionsByUserGraphData;
                    vm.taskCompletionsByUserGraphLabels = data.TaskCompletionsByUserGraphLabels;

                    vm.logCompletionsGraphData = data.LogCompletionsGraphData;
                    vm.logCompletionsGraphLabels = data.LogCompletionsGraphLabels;
                    vm.logCompletionsByDepartmentGraphData = data.LogCompletionsByDepartmentGraphData;
                    vm.logCompletionsByDepartmentGraphLabels = data.LogCompletionsByDepartmentGraphLabels;
                    vm.logCompletionsByUserGraphData = data.LogCompletionsByUserGraphData;
                    vm.logCompletionsByUserGraphLabels = data.LogCompletionsByUserGraphLabels;
                    vm.generated = true;
                }, function (error) { });
        }

    }
})();
